import { createSlice } from "@reduxjs/toolkit";

const ModelSlice = createSlice({
  name: "model",
  initialState: {
    data: null,
    status: false,
    error: null,
  },
  reducers: {
    ModelStart: (state) => {
      state.status = true;
    },
    ModelSuccess: (state, action) => {
      state.status = false;
      state.data = action.payload;
    },
    ModelFailure: (state, action) => {
      state.status = false;
      state.error = action.payload;
    },
  },
});

export const { ModelStart, ModelSuccess, ModelFailure } = ModelSlice.actions;

export default ModelSlice.reducer;
